import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonUploadForm } from "../../../Pages/VideoLessons/Ivideolessons";

// Combine both for IVideoUpload
type IVideoUpload = VideoLessonUploadForm;

const initialState: IReduxState<IVideoUpload> = {
  data: {} as IVideoUpload,
  isLoading: false,
};

export const DeleteVideoUploadSlice = createSlice({
  name: "DeleteVideoUploadSlice",
  initialState,
  reducers: {
    deleteVideoUpload: (state, _: PayloadAction<string>) => {
      state.isLoading = true;
    },
    successDeleteVideoUpload: (state, action: PayloadAction<IVideoUpload>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDeleteVideoUpload: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteVideoUploadResponse: (state) => {
      state.data = {} as IVideoUpload;
    },
  },
});

export const {
  deleteVideoUpload,
  failureDeleteVideoUpload,
  successDeleteVideoUpload,
  clearDeleteVideoUploadResponse,
} = DeleteVideoUploadSlice.actions;

export default DeleteVideoUploadSlice.reducer;
